import * as React from "react";
import {
  InitialStateMinimumRequirements_Analytics,
  InitialStateMinimumRequirements_GraphQl,
  InitialStateMinimumRequirements_Pack_JoinDrawerFull,
} from "../../../Common";

interface ReactPdpInitialStateConsumerInterface {
  initialState: ReactPdpInitialState;
}

interface ReactPdpInitialState
  extends InitialStateMinimumRequirements_GraphQl,
    InitialStateMinimumRequirements_Analytics,
    InitialStateMinimumRequirements_Pack_JoinDrawerFull {
  productId?: string;
}

const defaultValue = {} as unknown as ReactPdpInitialStateConsumerInterface;

const ReactPdpInitialStateContext = React.createContext(defaultValue);

interface ReactPdpInitialStateProviderProps {
  mountElement: Element | null;
}

export const ReactPdpInitialStateProvider: React.FunctionComponent<
  ReactPdpInitialStateProviderProps
> = (props) => {
  const initialState = React.useMemo(() => {
    const mountElement = (props.mountElement || {}) as HTMLElement;

    const initialStateJsonString =
      mountElement?.dataset.reactPdp__initialstate || "{}";

    const initialState = JSON.parse(
      initialStateJsonString
    ) as ReactPdpInitialState;
    return initialState;
  }, [props.mountElement]);
  const value: ReactPdpInitialStateConsumerInterface = React.useMemo(
    () => ({
      initialState,
    }),
    [initialState]
  );
  return (
    <ReactPdpInitialStateContext.Provider value={value}>
      {props?.children || []}
    </ReactPdpInitialStateContext.Provider>
  );
};

export const useReactPdpInitialState = () => {
  const context = React.useContext(ReactPdpInitialStateContext);
  if (context === defaultValue) {
    throw new Error(
      "useReactPdpInitialState must be used within a ReactPdpInitialStateProvider"
    );
  }
  return context;
};
